module.exports = __webpack_public_path__ + "img/Star-and-stripes-wall-art-thumb.jpg";